module.exports = __webpack_public_path__ + "static/mo24-3a2092556ea06da4cf42e7934c7fab1b.png";